import { adminAuth, adminRequest } from './adminAuth';
const mutate = async (action) => {
    const { csrfToken } = await adminAuth.csrf();
    return adminRequest(`/api/admin/downloads/${action}.php`, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken },
        body: JSON.stringify({})
    });
};
export const adminDownloads = {
    current: () => adminRequest('/api/admin/downloads/current.php'),
    regenerate: () => mutate('regenerate'),
    revoke: () => mutate('revoke')
};
